import { h } from 'preact'
import { useEffect, useState } from 'preact/compat'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { PAYMENT_METHOD_TYPES } from '../../../constants/paymentMethods'
import Card from '../../PaymentButtons/Card'
import ApplePay from '../../PaymentButtons/ApplePay'
import OmnioCard from '../../PaymentButtons/OmnioCard'
import PayPal from '../../PaymentButtons/PayPal'
import IDeal from '../../PaymentButtons/Ideal'
import PayPalCredit from '../../PaymentButtons/PayPalCredit'
import DirectDebit from '../../PaymentButtons/DirectDebit'
import GooglePay from '../../PaymentButtons/GooglePay'
import Bancontact from '../../PaymentButtons/Bancontact'
import Trustly from '../../PaymentButtons/Trustly'
import Vipps from '../../PaymentButtons/Vipps'
import MobilePay from '../../PaymentButtons/MobilePay'
import Swish from '../../PaymentButtons/Swish'
import Walley from '../../PaymentButtons/Walley'
import CustomPaymentMethod from '../../PaymentButtons/CustomPaymentMethod'
import { transactionDetailsSelector } from '../../../redux/slice/transactionDetailsSlice'
import { pageStateSelector } from '../../../redux/slice/pageStateSlice'

const pagesMap = new Map([
  [PAYMENT_METHOD_TYPES.Card.toLowerCase(), Card],
  [PAYMENT_METHOD_TYPES.ApplePay.toLowerCase(), ApplePay],
  [PAYMENT_METHOD_TYPES.GooglePay.toLowerCase(), GooglePay],
  [PAYMENT_METHOD_TYPES.IDeal.toLowerCase(), IDeal],
  [PAYMENT_METHOD_TYPES.Bancontact.toLowerCase(), Bancontact],
  [PAYMENT_METHOD_TYPES.PayPal.toLowerCase(), PayPal],
  [PAYMENT_METHOD_TYPES.PayPalCredit.toLowerCase(), PayPalCredit],
  [PAYMENT_METHOD_TYPES.DirectDebit.toLocaleLowerCase(), DirectDebit],
  [PAYMENT_METHOD_TYPES.Trustly.toLocaleLowerCase(), Trustly],
  [PAYMENT_METHOD_TYPES.Vipps.toLocaleLowerCase(), Vipps],
  [PAYMENT_METHOD_TYPES.Walley.toLocaleLowerCase(), Walley],
  [PAYMENT_METHOD_TYPES.MobilePay.toLocaleLowerCase(), MobilePay],
  [PAYMENT_METHOD_TYPES.Swish.toLocaleLowerCase(), Swish],
  ['omniocard', OmnioCard]
])

/**
 * @param {String} paymentMethod
 * @returns
 */
const getPage = paymentMethod =>
  pagesMap.get(paymentMethod?.toLocaleLowerCase())

const PaymentButton = ({
  watch,
  errors,
  handleSubmit,
  paymentMethod,
  showPaymentConfirmation,
  loaderImage,
  iframeRef,
  setSwishQrCode,
  getValues,
}) => {
  const [isGoBackButtonVisible, setIsGoBackButtonVisible] = useState(false)
  const pageState = useSelector(pageStateSelector)
  const transactionDetails = useSelector(transactionDetailsSelector)
  const PageComponent =
    getPage(pageState.isCardNumberOmnio ? 'omnioCard' : paymentMethod) ||
    CustomPaymentMethod

  useEffect(() => {
    const hasReturnUrl = transactionDetails?.returnUrl
    const hasOnlyOnePaymentMethod =
      pageState.displayedPaymentMethods.length === 1
    const hasCardOrIdealPaymentMethod =
      pageState.displayedPaymentMethods.includes(PAYMENT_METHOD_TYPES.Card) ||
      pageState.displayedPaymentMethods.includes(PAYMENT_METHOD_TYPES.IDeal)

    setIsGoBackButtonVisible(
      hasReturnUrl && hasOnlyOnePaymentMethod && hasCardOrIdealPaymentMethod,
    )
  }, [pageState.displayedPaymentMethods])

  return (
    PageComponent && (
      <tui-payments-button className="mfe-component">
        <PageComponent
          watch={watch}
          errors={errors}
          handleSubmit={handleSubmit}
          showPaymentConfirmation={showPaymentConfirmation}
          isGoBackButtonVisible={isGoBackButtonVisible}
          loaderImage={loaderImage}
          paymentMethod={paymentMethod}
          iframeRef={iframeRef}
          setSwishQrCode={setSwishQrCode}
          getValues={getValues}
        />
      </tui-payments-button>
    )
  )
}

PaymentButton.propTypes = {
  watch: PropTypes.func,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  getValues: PropTypes.func,
  paymentMethod: PropTypes.string,
  showPaymentConfirmation: PropTypes.bool,
  loaderImage: PropTypes.string,
  iframeRef: PropTypes.object,
}

export default PaymentButton
